// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .shadow-nav {
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 10;
  transition: all ease-in-out 0.5s;
} */
nav {
  font-size: 15px;
  background: #fff;
  height: 100vh;
  width: 258px;
  z-index: 0;
  position: fixed;
  transition: all ease-in-out 0.4s;
  top: 0;
  left: 0;
  border-right: 1px solid lightgray;
  box-shadow: 1px 0px 4px lightgray;
  overflow: auto;
}
/* @media only screen and (max-width: 600px) {
    nav {
      left: -100%;
    }
  } */
.side_bar_top {
  background-color: #fff;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid lightgray;
  box-shadow: 0 1px 4px 1px lightgray;
  position: fixed;
  width: 258px;
  z-index: 10;
  transition: all 0.4s ease-in-out 0s;
  padding: 14px 0;
  min-height: 60px;
}
.side_bar_top a {
  padding: 0;
  line-height: 1;
  width: 100%;
}
.side_bar_top .navbar-brand-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
}
.side_bar_top .logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.side_bar_top .logo img {
  max-width: 100%;
  height: auto;
}
.activeitem {
  color: #fbb062; /* Brand Warm Orange */
  cursor: pointer;
}
.sidebar-nav-item {
  border-bottom: 1px solid lightgray;
  padding-bottom: 15px;
  padding-top: 15px;
  padding-left: 15px;
  font-size: 15px;
  cursor: pointer;
}
nav ul {
  padding: 0 0;
  list-style: none;
  margin-top: 80px;
}

nav li {
  padding: 5px 5px;
}
nav li a {
  position: relative;
  padding: 10px 15px 10px 15px;
  color: #fff;
  transition: all ease-in-out 0.2s;
}
nav li a:hover {
  color: rgb(11 23 248);
}
nav li .active::before {
  content: '';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  background-color: #fff;
  height: 100%;
  width: 5px;
  z-index: 20;
}
.nav_show {
  width: 100px;
}
.nav_show .side_bar_top {
  width: 100px;
  padding: 14px 10px;
}
.nav_show .side_bar_top .navbar-brand-box {
  padding: 0 10px;
}
.nav_show > ul li a {
  padding: 0;
  display: flex;
  font-size: 12px;
  word-break: break-all;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  text-align: center;
}
.nav_show > ul li a i {
  font-size: 20px;
}
body[data-layout='horizontal'] #page-topbar {
  left: 250px;
}
.nav_show body[data-layout='horizontal'] #page-topbar {
  left: 10px;
}
.grow-menu {
  padding-left: 266px;
  transition: all ease-in-out 0.4s;
}
.shrink-menu {
  padding-left: 90px;
  transition: all ease-in-out 0.4s;
}
.nested-item {
  cursor: pointer;
  background-color: #f8f9fa;
  border: none;
  font-size: 15px;
  padding: 8px 8px 8px 36px;
}

.color-rgb {
  color: rgb(11 23 248);
  font-weight: 500;
}

.color-black {
  color: black;
}

/* Logo visibility controls */
.logo .logo-sm {
  display: none;
}

.logo .logo-lg {
  display: block;
}

/* When sidebar is collapsed (nav_show class) */
.nav_show .logo .logo-sm {
  display: block;
}

.nav_show .logo .logo-lg {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/views/Layout/layout.css"],"names":[],"mappings":"AAAA;;;;;;;GAOG;AACH;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gCAAgC;EAChC,MAAM;EACN,OAAO;EACP,iCAAiC;EACjC,iCAAiC;EACjC,cAAc;AAChB;AACA;;;;KAIK;AACL;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,mCAAmC;EACnC,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc,EAAE,sBAAsB;EACtC,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* .shadow-nav {\n  background-color: rgba(0, 0, 0, 0.5);\n  height: 100%;\n  width: 100%;\n  position: relative;\n  z-index: 10;\n  transition: all ease-in-out 0.5s;\n} */\nnav {\n  font-size: 15px;\n  background: #fff;\n  height: 100vh;\n  width: 258px;\n  z-index: 0;\n  position: fixed;\n  transition: all ease-in-out 0.4s;\n  top: 0;\n  left: 0;\n  border-right: 1px solid lightgray;\n  box-shadow: 1px 0px 4px lightgray;\n  overflow: auto;\n}\n/* @media only screen and (max-width: 600px) {\n    nav {\n      left: -100%;\n    }\n  } */\n.side_bar_top {\n  background-color: #fff;\n  justify-content: center;\n  align-items: center;\n  border-bottom: 1px solid lightgray;\n  box-shadow: 0 1px 4px 1px lightgray;\n  position: fixed;\n  width: 258px;\n  z-index: 10;\n  transition: all 0.4s ease-in-out 0s;\n  padding: 14px 0;\n  min-height: 60px;\n}\n.side_bar_top a {\n  padding: 0;\n  line-height: 1;\n  width: 100%;\n}\n.side_bar_top .navbar-brand-box {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 15px;\n}\n.side_bar_top .logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.side_bar_top .logo img {\n  max-width: 100%;\n  height: auto;\n}\n.activeitem {\n  color: #fbb062; /* Brand Warm Orange */\n  cursor: pointer;\n}\n.sidebar-nav-item {\n  border-bottom: 1px solid lightgray;\n  padding-bottom: 15px;\n  padding-top: 15px;\n  padding-left: 15px;\n  font-size: 15px;\n  cursor: pointer;\n}\nnav ul {\n  padding: 0 0;\n  list-style: none;\n  margin-top: 80px;\n}\n\nnav li {\n  padding: 5px 5px;\n}\nnav li a {\n  position: relative;\n  padding: 10px 15px 10px 15px;\n  color: #fff;\n  transition: all ease-in-out 0.2s;\n}\nnav li a:hover {\n  color: rgb(11 23 248);\n}\nnav li .active::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0;\n  background-color: #fff;\n  height: 100%;\n  width: 5px;\n  z-index: 20;\n}\n.nav_show {\n  width: 100px;\n}\n.nav_show .side_bar_top {\n  width: 100px;\n  padding: 14px 10px;\n}\n.nav_show .side_bar_top .navbar-brand-box {\n  padding: 0 10px;\n}\n.nav_show > ul li a {\n  padding: 0;\n  display: flex;\n  font-size: 12px;\n  word-break: break-all;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  text-align: center;\n}\n.nav_show > ul li a i {\n  font-size: 20px;\n}\nbody[data-layout='horizontal'] #page-topbar {\n  left: 250px;\n}\n.nav_show body[data-layout='horizontal'] #page-topbar {\n  left: 10px;\n}\n.grow-menu {\n  padding-left: 266px;\n  transition: all ease-in-out 0.4s;\n}\n.shrink-menu {\n  padding-left: 90px;\n  transition: all ease-in-out 0.4s;\n}\n.nested-item {\n  cursor: pointer;\n  background-color: #f8f9fa;\n  border: none;\n  font-size: 15px;\n  padding: 8px 8px 8px 36px;\n}\n\n.color-rgb {\n  color: rgb(11 23 248);\n  font-weight: 500;\n}\n\n.color-black {\n  color: black;\n}\n\n/* Logo visibility controls */\n.logo .logo-sm {\n  display: none;\n}\n\n.logo .logo-lg {\n  display: block;\n}\n\n/* When sidebar is collapsed (nav_show class) */\n.nav_show .logo .logo-sm {\n  display: block;\n}\n\n.nav_show .logo .logo-lg {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
